import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import './header.css'

// Dynamic Header
const Header = () => {
  const { settings } = useSelector((state) => state.Home);
  const location = useLocation(); // Get current route
  const [menuData, setMenuData] = useState([]);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // State for mobile menu toggle
  const [mobileSubMenus, setMobileSubMenus] = useState({});

  const getMenuData = () => {
    axios.get(`${process.env.REACT_APP_URL}/pagemenu/journal`)
      .then((res) => {
        console.log(res?.data, "menu data response");
        setMenuData(res?.data?.data);
      })
      .catch((err) => {
        console.log(err, "menu data error");
      });
  };

  useEffect(() => {
    getMenuData();
    // Do not reset menu state on every route change
    // We will handle this in the click handlers
  }, [location.pathname]); // Keep the dependency to fetch menu data on route change

  // Toggle mobile menu
  const toggleMobileMenu = () => {
    setMobileMenuOpen((prev) => !prev);
    document.body.classList.toggle("menu-opened");
  };

  // Toggle mobile submenu
  const toggleMobileSubMenu = (menuId) => {
    setMobileSubMenus((prev) => ({
      ...prev,
      [menuId]: !prev[menuId],
    }));
  };

  const Changeroute = (slugDD) => {
    console.log(slugDD, 'slugDD');
    let routePath = '';
    if (slugDD === "a-z-journals") {
      routePath = `/filter/${slugDD}`
    }
    else if (slugDD === "browse-by-subject") {
      routePath = `/subject-filter/${slugDD}`
    }
    else if(slugDD==="Home")
    {
      routePath="/"
    }
    else if(slugDD==="contact-us")
    {
      routePath="/contact-us"
    }
    else {
      // routePath = `/pageData/${slugDD}`
      routePath = `/${slugDD}`

    }
    return routePath;
  };

  const renderSubMenu = (subMenu, parentId) => {
    if (!subMenu || subMenu.length === 0) return null;

    return (
      <ul
        className={`submenu ${mobileSubMenus[parentId] ? "submenuShow" : ""}`}
        style={{
          display: mobileSubMenus[parentId] ? "block" : undefined,
        }}
      >
        {subMenu.map((item) => (
          <li
            key={item._id}
            className={item.sub_menu?.length > 0 ? "has-submenu" : ""}
            onMouseEnter={(e) => {
              if (window.innerWidth > 991) {
                const submenu = e.currentTarget.querySelector(".submenu");
                if (submenu) submenu.style.display = "block";
              }
            }}
            onMouseLeave={(e) => {
              if (window.innerWidth > 991) {
                const submenu = e.currentTarget.querySelector(".submenu");
                if (submenu) submenu.style.display = "none";
              }
            }}
          >
            <Link
              to={Changeroute(item.slug)}
              className={
                location.pathname.toLowerCase().replace(/\/$/, '') === Changeroute(item.slug)
                  ? "active"
                  : ""
              }
              style={{
                textDecoration: "none",
                padding: "10px 15px",
                display: "block",
                color: "#333",
              }}
                        onClick={(e) => {
            if (item.sub_menu?.length > 0 && window.innerWidth <= 991) {
              e.preventDefault();
              toggleMobileSubMenu(item._id);
            } else {
              // Scroll to top for all navigation clicks
              window.scrollTo(0, 0);
              if (window.innerWidth <= 991) {
                setMobileMenuOpen(false);
                document.body.classList.remove("menu-opened");
              }
            }
          }}
            >
              {item.menu} {item.sub_menu?.length > 0 && <i className="fas fa-chevron-down"></i>}
            </Link>
            {renderSubMenu(item.sub_menu, item._id)}
          </li>
        ))}
      </ul>
    );
  };

  const renderMenu = () => {
    return menuData.map((menu) => (
      <li
        key={menu._id}
        className={menu.sub_menu?.length > 0 ? "has-submenu" : ""}
        onMouseEnter={(e) => {
          if (window.innerWidth > 991) {
            const submenu = e.currentTarget.querySelector(".submenu");
            if (submenu) submenu.style.display = "block";
          }
        }}
        onMouseLeave={(e) => {
          if (window.innerWidth > 991) {
            const submenu = e.currentTarget.querySelector(".submenu");
            if (submenu) submenu.style.display = "none";
          }
        }}
      >
        <Link
          to={menu.sub_menu?.length <= 0 ? Changeroute(menu.slug) : '#'}
          className={
            location.pathname.toLowerCase().replace(/\/$/, '') === Changeroute(menu.slug)
              ? "active"
              : ""
          }
          style={{
            textDecoration: "none",
            padding: "10px 15px",
            display: "block",
            color: "#333",
          }}
          onClick={(e) => {
            if (menu.sub_menu?.length > 0 && window.innerWidth <= 991) {
              e.preventDefault();
              toggleMobileSubMenu(menu._id);
            } else {
              // Scroll to top for all navigation clicks
              window.scrollTo(0, 0);
              if (window.innerWidth <= 991) {
                setMobileMenuOpen(false);
                document.body.classList.remove("menu-opened");
              }
            }
          }}
        >
          {menu.menu} {menu.sub_menu?.length > 0 && <i className="fas fa-chevron-down"></i>}
        </Link>
        {renderSubMenu(menu.sub_menu, menu._id)}
      </li>
    ));
  };

  return (
    <header className="header">
      <div className="header-fixed">
        <nav className="navbar navbar-expand-lg header-nav add-header-bg">
          <div className="container">
            <div className="navbar-header">
              <Link id="mobile_btn" to="#" onClick={toggleMobileMenu}>
                <span className="bar-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </Link>
              <Link to="/" className="navbar-brand logo">
                <img
                  src={settings?.data?.color_logo_url}
                  crossOrigin="anonymous"
                  alt="Logo"
                  className="logo-img"
                  onClick={()=>window.scrollTo(0,0)}
                />
              </Link>
            </div>
            <div className={`main-menu-wrapper ${mobileMenuOpen ? "menu-opened" : ""}`}>
              <div className="menu-header">
                <Link to="/" className="menu-logo">
                  <img
                    src={settings?.data?.color_logo_url}
                    crossOrigin="anonymous"
                    alt="Logo"
                    className="logo-img"
                    onClick={()=>window.scrollTo(0,0)}
                  />
                </Link>
                <Link
                  id="menu_close"
                  className="menu-close"
                  to="#"
                  onClick={toggleMobileMenu}
                >
                  <i className="fas fa-times" onClick={()=>window.scrollTo(0,0)}/>
                </Link>
              </div>
              <ul className="main-nav">{renderMenu()}</ul>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;